exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-6695ef79]{padding:0 20px !important}.dashboard-console-grid[data-v-6695ef79]{text-align:center}.dashboard-console-grid .ivu-card-body[data-v-6695ef79]{padding:0}.dashboard-console-grid i[data-v-6695ef79]{font-size:32px}.dashboard-console-grid a[data-v-6695ef79]{display:block;color:inherit}.dashboard-console-grid p[data-v-6695ef79]{margin-top:8px}", ""]);

// exports
